module.exports = __webpack_public_path__ + "img/device_cb02.89641933.png";